import { Component, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Router } from "@angular/router";
import { LoaderService } from "@app/@shared/services/loader.service";
import { TranslateService } from "@ngx-translate/core";
import { HomeService } from "../home.service";

@Component({
  selector: "app-platform-user",
  templateUrl: "./platform-user.component.html",
  styleUrls: ["./platform-user.component.scss"],
})
export class PlatformUserComponent implements OnInit {
  routeId: string | null;
  platformUser: any;

  constructor(
    private homeService: HomeService,
    private route: ActivatedRoute,
    private router: Router,
    private loaderService: LoaderService,
    private translateService: TranslateService,
    private _snackBar: MatSnackBar
  ) {
    this.routeId = this.route.snapshot.paramMap.get("id");
    if (this.routeId) {
      this.getPlatformUser(this.routeId);
    } else {
      this.router.navigate(["/"]);
    }
  }

  ngOnInit(): void {}

  editInformation() {
    this.router.navigateByUrl(`edit-administrator/${this.platformUser.id}`, {
      state: this.platformUser,
    });
  }

  resetPassword(email: string) {
    if (email) {
      this.loaderService.shouldRunLoader.next(true);

      this.homeService.requestNewPassword(email).subscribe(
        (response) => {
          this._snackBar.open(
            this.translateService.instant("lbl-sent-email"),
            this.translateService.instant("lbl-cancel"),
            {
              panelClass: ["success-snackbar"],
            }
          );

          this.loaderService.shouldRunLoader.next(false);
        },
        (error) => {
          this._snackBar.open(
            this.translateService.instant("lbl-something-wrong"),
            this.translateService.instant("lbl-cancel"),
            {
              panelClass: ["error-snackbar"],
            }
          );
          this.loaderService.shouldRunLoader.next(false);
        }
      );
    }
  }

  getBeneficiaries(user: any) {
    return user ? user.beneficiaries : [];
  }

  private getPlatformUser(id: string) {
    this.homeService.getPlatformUserById(+id).subscribe(
      (response) => {
        this.platformUser = response;
      },
      (error) => {
        console.log(error);
      }
    );
  }
}
